import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import OpenModal from "./OpenModal";

class RenderOpenModals extends Component {
  render() {
    const { stores } = this.props;

    const modals = stores.ui.modals.map((handler, index) => {
      return <OpenModal key={`modal_${index}`} handler={handler} />;
    });

    return <React.Fragment>{modals}</React.Fragment>;
  }
}

export default inject("stores")(observer(RenderOpenModals));



// WEBPACK FOOTER //
// ./src/Core/Components/OpenModals/index.js